const { applicationName } = require('../configs/application');
const { logger } = require('./logger');

const logPrefix = '[@tyc/cat]';
let cat;

if (!cat) {
  try {
    const tycCat = require('@tyc/cat');
    tycCat.init({ appkey: applicationName });
    tycCat.logger = logger.prefix(logPrefix);
    cat = tycCat;
    logger.info(`${logPrefix} Inited`);
  } catch (err) {
    logger.error(`${logPrefix} Init failed`, err);
  }
}

module.exports = cat || {};
